import React from "react"
import Styles from "./ForHealthCoachHeaderSectionStyle.module.styl"
import Image from "gatsby-image"
import translate, { keys } from "../../../../../translation/translator"

const ForHealthCoachHeaderSection = ({
  healthCoachHeaderImage,
  handleChangeEmail,
  handleSubmit,
  email,
  path,
  errors,
  loading,
  locale,
}) => {
  const headerImage = healthCoachHeaderImage[0].node.childImageSharp.fluid
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.description}>
        <h2 className={Styles.section_title}>
          {translate(keys.HLTH_COACH_HEADER_PROFIT, locale)}
        </h2>
        <p>{translate(keys.HLTH_COACH_HEADER_DESC, locale)} </p>
        {loading === true ? (
          <div className="loader" />
        ) : (
          <form onSubmit={handleSubmit} className={Styles.input_holder}>
            <input
              value={email}
              onChange={handleChangeEmail}
              type="text"
              name="EMAIL"
              placeholder="name@youremail.com"
            />
            <input type="hidden" value={path} name="URL" />
            <button type="button" onClick={handleSubmit}>
              {translate(keys.HLTH_COACH_HEADER_FREE_ACS, locale)}
            </button>
          </form>
        )}

        <span className="home_consultation_error">
          {errors.email && errors.email}
        </span>
      </div>
      <div className={Styles.image_holder}>
        <Image alt="health-coach" fluid={headerImage} />
      </div>
    </div>
  )
}

export default ForHealthCoachHeaderSection
